export default __webpack_public_path__ + "static/media/chi.45bfc3a3.svg";